export default {
    ieltsExamLabel: "IELTS",
    ieltsExamShortInfo: "International English Language Testing System — Academic & General.",
    ieltsExamLabelFull: "International English Language Testing System",
    ieltsExamDescription: "IELTS is one of the world's leading English proficiency tests, accepted for study, work and migration. It assesses listening, reading, writing and speaking. LinguaScore offers preparation for both Academic and General Training modules with full-length mock tests and targeted practice.",
    ieltsExamStructure: "Listening (30 min), Reading (60 min), Writing (60 min), Speaking (11–14 min). Results are reported as band scores from 0 to 9.",
    ieltsBeginnerTierDescription: "Very limited or no English ability",
    ieltsElementaryTierDescription: "Basic understanding with frequent errors",
    ieltsIntermediateTierDescription: "Partial command of the language",
    ieltsUpperIntermediateTierDescription: "Effective communication in most situations",
    ieltsAdvancedTierDescription: "Good operational command",
    ieltsProficientTierDescription: "Very fluent and accurate English",
    ieltsSectionTerminology:"Part {{sectionNumber}}",
    ieltsSpeakingPartOneLabel:"Introduction and Interview",
    ieltsSpeakingPartTwoLabel:"Individual Long Turn",
    ieltsSpeakingPartThreeLabel:"Two-way Discussion",
    ieltsSpeakingCandidateLabel:"You",
    ieltsSpeakingExaminerLabel:"Examiner",
    ieltsSpeakingExaminerActionLabel:"Speaking...",
    ieltsSpeakingManualListeningActionLabel:"Tap to Listen",
    ieltsSpeakingRecordingLabel:"Recording: {{seconds}}",

    tcfExamLabel: "TCF",
    tcfCAExamLabel: "TCF Canada",
    tcfExamShortInfo: "Test de connaissance du français — for studies and immigration in France.",
    tcfCAExamShortInfo: "TCF for Canada — French proficiency for Canadian immigration.",
    tcfExamLabelFull: "Test de Connaissance du Français",
    tcfFRBeginnerTierDescription: "Very basic French knowledge",
    tcfFRElementaryTierDescription: "Simple everyday communication",
    tcfFRIntermediateTierDescription: "Independent user",
    tcfFRUpperIntermediateTierDescription: "Comfortable and accurate French",
    tcfFRAdvancedTierDescription: "Fluent and structured language use",
    tcfFRProficientTierDescription: "Mastery of French",

    tcfCABeginnerTierDescription: "Minimal communication ability",
    tcfCAElementaryTierDescription: "Basic functional proficiency",
    tcfCAIntermediateTierDescription: "Meets the minimum immigration requirement",
    tcfCAUpperIntermediateTierDescription: "Strong working proficiency",
    tcfCAAdvancedTierDescription: "High impact on your CRS score",
    tcfCAProficientTierDescription: "Near-native proficiency",

    toeflExamLabel: "TOEFL",
    toeflExamShortInfo: "Test of English as a Foreign Language — recognised worldwide.",
    toeflExamLabelFull: "Test Of English as a Foreign Language",
    toeflExamDescription: "TOEFL is widely used for university admissions and professional certification in English-speaking environments. The test measures reading, listening, speaking and writing in an academic context. Prepare with LinguaScore's practice tests and resources aligned to the TOEFL iBT format.",
    toeflExamStructure: "Reading (54–72 min), Listening (41–57 min), Speaking (17 min), Writing (50 min). Total score 0–120.",
    toeflBeginnerTierDescription: "Very limited English proficiency",
    toeflElementaryTierDescription: "Basic communication skills",
    toeflIntermediateTierDescription: "Functional academic English",
    toeflUpperIntermediateTierDescription: "Good academic performance",
    toeflAdvancedTierDescription: "Strong academic proficiency",
    toeflProficientTierDescription: "Near-native academic English",

    beginnerTierLabel: "Beginner",
    elementaryTierLabel: "Elementary",
    intermediateTierLabel: "Intermediate",
    upperIntermediateTierLabel: "Upper Intermediate",
    advancedTierLabel: "Advanced",
    proficientTierLabel: "Proficient",

    listeningSectionLabel: "Listening",
    readingSectionLabel: "Reading",
    speakingSectionLabel: "Speaking",
    writingSectionLabel: "Writing",

    languageTestSetupTitle:"Language Test Setup",
    languageTestSetupDescription:"Tell us more about your exam and expectations",
    languageTestSetupActionLabel: "Submit",
    examSessionLabel:"Session",
    examSoonAvailableLabel:"Coming soon"
}